export default {
  APP_VERSION: '1.0.0',

  // AUTH
  URL_USER_LOGIN: '/auth/login',
  URL_VALIDATE_AUTH_TOKEN: '/auth/token',
  URL_CHANGE_PASSWORD: '/auth/changePassword/client',
  URL_RESET_PASSWORD: '/auth/reset/client',
  URL_PASSWORD_RESET_CONFIRM: '/auth/reset/confirm/:modelType',

  // TRAINER
  URL_TRAINER_PUBLIC_BIO: '/trainer/:trainerID/public-bio',

  // CLIENT
  URL_SIGNUP_CLIENT: 'client/signup',
  // may not actually be needed since auth/token returns a complete user obj.
  // URL_CLIENT_DETAILS: '/client/:clientID?trainer_id=:trainerID',
  URL_CLIENT_CHECKOUT: '/client/checkout',
  URL_CLIENT_COUPON_CODE: '/client/coupon',
  URL_UPDATE_CLIENT: '/client/:clientID?trainer_id=:trainerID',
  URL_HOME_OVERVIEW: '/client/homeOverview?today=:yyyy-mm-dd',
  URL_PROGRESS_DETAILS: '/client/progressDetails?today=:yyyy-mm-dd',
  URL_NOTIFICATIONS: '/client/notifications?today=:yyyy-mm-dd',
  URL_START_WORKOUT: '/client/startWorkout',
  URL_UPDATE_WORKOUT: '/client/updateCurrentWorkout',
  URL_COMPLETE_WORKOUT: '/client/completeWorkout',
  URL_START_CHECKIN: '/client/:clientID/scheduledCheckIn/:scheduledCheckInID/start',
  URL_UPDATE_CHECKIN: '/client/:clientID/scheduledCheckIn/:scheduledCheckInID',
  URL_COMPLETE_CHECKIN: '/client/:clientID/scheduledCheckIn/:scheduledCheckInID/complete',
  URL_GET_HOME_OVERVIEW: '/client/homeOverview?today=:today',
  URL_GET_PROGRESS_DETAILS: '/client/progressDetails?today=:today',

  // PROGRAM
  URL_PROGRAM_DAY_DETAILS: '/program/day/:programDayID?org_id=:orgID&trainer_id=:trainerID&user_id=:userID',

  // EXERCISE
  URL_EXERCISE_DETAILS: '/exercise/:exerciseID?trainer_id=:trainerID&org_id=:orgID',

  // ORG
  URL_ORG_DETAILS: '/org/:orgID',
  URL_SIGNED_URL: '/org/:orgID/signedUrl?requestType=clients&trainerId=:trainerID',
  URL_GET_ORG_S3_UPLOAD_ENDPOINT: '/org/:orgID/signedUrl?requestType=:requestType&trainerId=:trainerID',
};
